import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Async thunk to fetch event details
export const fetchEventDetails = createAsyncThunk(
  "event/fetchEventDetails",
  async (slug, { rejectWithValue }) => {
    try {
      const res = await agent.get(`${API.EVENT_DETAIL}/${slug}`);
      return res.data.data; // backend sends event data in res.data.data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Async thunk for RSVP submission
export const submitRSVP = createAsyncThunk(
  "event/submitRSVP",
  async ({ data, setShow, setLoader }, { rejectWithValue }) => {
    try {
      // here call your RSVP API, I'm assuming `API.HANDLE_RSVP`
      const res = await agent.post(API.SUBMIT_RSVP, data);
      if (res.status === 200) {
        setShow(false);
        setLoader(false);
      }
      return res.data;
    } catch (err) {
      setLoader(false);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  eventDetail: {},
  likeCount: 0,
  loading: false,
  error: null,
  success: false,
};

const eventDetailSlice = createSlice({
  name: "eventDetail",
  initialState,
  reducers: {
    resetEventState: (state) => {
      state.eventDetail = {};
      state.likeCount = 0;
      state.loading = false;
      state.error = null;
      state.success = false;
    },
    setLikeCount: (state, action) => {
      state.likeCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.eventDetail = action.payload;
        state.likeCount = action.payload.likes_count || 0;
      })
      .addCase(fetchEventDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitRSVP.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitRSVP.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(submitRSVP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetEventState, setLikeCount } = eventDetailSlice.actions;
export default eventDetailSlice.reducer;
